import React from "react";
import { useSeriesShowContext } from "../SeriesShowApp";
import PassHolderLimitCard from "./PassHolderLimitCard";
import SellPassesButton from "./SellPassesButton";
import { fmtPrice } from "../passFormatting";

const KIND_LABELS = {
  season_pass: "Season Pass",
  flex_pack: "Flex Pack",
};

const kindLabel = (product) => (
  product.product_kind === "flex_pack" && product.pack_size
    ? `Flex Pack · ${product.pack_size}`
    : KIND_LABELS[product.product_kind] || product.product_kind
);

// A series never sells passes itself. This tab lists, read only, what each
// collection that includes the series sells, and links to where they're edited.
const SeriesPassesTab = () => {
  const { series } = useSeriesShowContext();
  const collections = series.member_of_collections || [];
  const currency = series.base_currency_symbol;

  return (
    <>
      <div className="series-schedule-card" data-testid="series-passes-tab">
        <div className="series-schedule-header d-flex align-items-center justify-content-between">
          <div>
            <h4 className="series-schedule-title mb-0">Passes &amp; Packs</h4>
            <div className="text-muted small" data-testid="series-passes-subtitle">
              Passes and packs for this series are sold on collections that include it. Edit them on the collection.
            </div>
          </div>
          <SellPassesButton />
        </div>

        {collections.length === 0 ? (
          <div className="series-detail-card-body text-muted" data-testid="series-passes-empty">
            No collection includes this series yet. Sell passes for this series to start one.
          </div>
        ) : (
          collections.map((collection) => {
            const products = collection.series_pass_products || [];
            return (
              <div key={collection.id} className="series-detail-card-body" data-testid={`series-passes-collection-${collection.id}`}>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <a href={collection.passes_url} className="series-schedule-td-strong">{collection.name}</a>
                </div>
                {products.length === 0 ? (
                  <div className="text-muted small">
                    No passes or packs yet. <a href={collection.passes_url}>Create one on {collection.name}</a>.
                  </div>
                ) : (
                  <table className="table mb-0 series-schedule-table">
                    <thead>
                      <tr>
                        <th className="series-schedule-th series-schedule-th-first">Pass</th>
                        <th className="series-schedule-th">Type</th>
                        <th className="series-schedule-th">Price</th>
                        <th className="series-schedule-th">Sold</th>
                        <th className="series-schedule-th">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {products.map((product) => (
                        <tr key={product.id} className="series-schedule-row" data-testid={`series-passes-product-${product.id}`}>
                          <td className="series-schedule-td-date series-schedule-td-strong">{product.name}</td>
                          <td className="series-schedule-td">{kindLabel(product)}</td>
                          <td className="series-schedule-td">{fmtPrice(product.price, currency)}</td>
                          <td className="series-schedule-td">{`${product.sold_count} / ${product.capacity}`}</td>
                          <td className="series-schedule-td">
                            <span className={`series-status-pill ${product.active ? "series-status-confirm" : "series-status-past"}`}>
                              {product.active ? "Active" : "Inactive"}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            );
          })
        )}
      </div>
      <PassHolderLimitCard />
    </>
  );
};

export default SeriesPassesTab;
